var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import cx from 'classnames';
import { Paper, makeStyles } from '@material-ui/core';
import units from '../theme/units';
var useStyles = makeStyles(function (theme) { return ({
    base: {
        display: 'inline-block',
        fontSize: units.rem(0.85),
        padding: units.trbl(0.25, 0.5, 0.25, 0.5),
    },
    'kind-mint': {
        color: '#fff',
        backgroundColor: theme.palette.secondary.main,
    },
    'kind-mint-left-no-radius': {
        color: '#fff',
        backgroundColor: theme.palette.secondary.main,
        borderTopLeftRadius: 0,
        borderBottomLeftRadius: 0,
    },
    'kind-muted': {
        backgroundColor: theme.palette.grey[200],
        color: theme.palette.secondary.main,
    },
}); });
var Badge = function (_a) {
    var _b;
    var kind = _a.kind, children = _a.children, rest = __rest(_a, ["kind", "children"]);
    var classes = useStyles();
    return (React.createElement(Paper, __assign({ elevation: 0, className: cx(classes.base, (_b = {},
            _b[classes["kind-" + kind]] = Boolean(kind),
            _b)) }, rest), children));
};
export default Badge;
//# sourceMappingURL=PaperBadge.js.map